import React, { useState, useEffect } from 'react';
import * as turf from '@turf/turf';

// Import components
import WidgetInfo from '../buildable/WidgetInfo';

// Import CSS & assets
import ico_map_layers from '../../../../assets/ico/ico_map_layers.svg';
import ico_arrow from '../../../../assets/ico/ico_arrow_up.svg';
import fade from '../../../../assets/fade_grey.svg';

// Import external functions
import * as helpers from '../../../../helpers/Other_helpers';
import * as map_helpers from '../../map/Map_helpers';

const LandsDivision = ({ capacity, setCapacity, mapLayers, setMapLayers, mapDrawMode, setMapDrawMode, setDivisionUpdateTracker }) => {

    // LAYER : Toggle
    const layer_Toggle = (layer) => {
        // console.log("TOGGLE LAYER", layer);
        // Get state
        var mapLayersState = mapLayers;
        // Update state
        mapLayersState[layer]["isVisible"] = !mapLayersState[layer]["isVisible"];
        // Update original
        setMapLayers({ ...mapLayersState });
    }
    // LAYER : Show
    const layer_Show = (layer) => {
        // console.log("HIDSHOWE LAYER", layer);
        // Get state
        var mapLayersState = mapLayers;
        // Update state
        mapLayersState[layer]["isVisible"] = true;
        // Update original
        setMapLayers({ ...mapLayersState });
    }
    // LAYER : Hide
    const layer_Hide = (layer) => {
        // console.log("HIDE LAYER", layer);
        // Get state
        var mapLayersState = mapLayers;
        // Update state
        mapLayersState[layer]["isVisible"] = false;
        // Update original
        setMapLayers({ ...mapLayersState });
    }

    // DRAWING
    const [isDrawing, setIsDrawing] = useState(false);
    const openDraw = () => {
        console.log("OPEN DRAW FROM DIVISION");
        console.log("capacity", capacity);
        setIsDrawing(true);
        // Check if starting division
        if (!capacity?.landBase?.division) {
            var landBase = { ...capacity.landBase };
            landBase.union_old = JSON.parse(JSON.stringify(landBase.union));
            // Add other data to memeory (limits, buildings inside...)
            landBase.union_old.memory = {
                calculated_values: JSON.parse(JSON.stringify(landBase.calculated_values)),
                buildings_close: JSON.parse(JSON.stringify(landBase.buildings.buildings_close)),
                buildings_land: JSON.parse(JSON.stringify(landBase.buildings.buildings_land)),
                buildings_land_area: JSON.parse(JSON.stringify(landBase.buildings.buildings_land_area)),
            }
            landBase.division = null;
            setCapacity({ ...capacity, landBase: landBase });
        }
        // Create draw features data
        var draw_data = {
            type: "FeatureCollection",
            features: []
        }
        // Add existing division elements
        if (capacity?.landBase?.division?.geo_data) {
            draw_data = capacity.landBase.division.geo_data;
        }
        // Hide layers
        layer_Hide("union");
        layer_Hide("division");
        // Set draw mode
        setMapDrawMode({ mode: "line", data: draw_data, target: { division: true } });
    }

    // ACTIONS
    const [isDelete, setIsDelete] = useState(false);
    const handleDeleteDivision = () => {
        var landBase = { ...capacity.landBase };
        landBase.union = JSON.parse(JSON.stringify(landBase.union_old));
        landBase.union_old = null;
        landBase.division = null;
        var toSaveData = { ...capacity.toSave };
        if (!toSaveData?.keys) { toSaveData.keys = [] }
        toSaveData.keys.push("landBase__union");
        toSaveData.keys.push("landBase__union_old");
        toSaveData.keys.push("landBase__division");
        toSaveData.autoSave = false; // Set to true later in processing (after recalculating buildable)
        toSaveData.action = "Suppression de la division du terrain";
        toSaveData.value = null;
        layer_Hide("division");
        setIsDelete(false);
        setCapacity({ ...capacity, landBase: landBase, toSave: toSaveData });
        setDivisionUpdateTracker((Date.now()).toString());
    }
    const handleSaveDivision = () => {
        console.log("SAVE DIVISION DATA", capacity);
        // Reset drawing mode
        setIsDrawing(false);
        setMapDrawMode({ mode: null, data: null, target: null });
        // Show layers
        layer_Show("union");
        layer_Show("division");
        // Recalculate values
        handleRecalculateUnion(capacity.landBase);
    }
    const handleRecalculateUnion = (landBase) => {
        console.log("DATA CALCULATION");
        // Check if at least one division zone is not taken
        var is_any_taken = false;
        for (var i = 0; i < landBase.division.division_areas.features.length; i++) {
            if (landBase.division.division_areas.features[i].properties.isTaken === false) {
                is_any_taken = true;
                break;
            }
        }
        if (is_any_taken) {
            // Recalculate union
            console.log("RECALCULATE");
            // Create new polyLand by differencing not taken division zones to union_old
            var polyLand = JSON.parse(JSON.stringify(landBase.union_old.geometry));
            for (var i = 0; i < landBase.division.division_areas.features.length; i++) {
                if (landBase.division.division_areas.features[i].properties.isTaken === false) {
                    polyLand = turf.difference(polyLand, landBase.division.division_areas.features[i]);
                }
            }
            // console.log("polyLand", polyLand);
            // console.log("union", landBase.union);
            var union_new = map_helpers.land_union_base(polyLand);
            // console.log("union_new", union_new);
            // Update bounds and calculated values
            union_new = recalculationBounds(union_new, landBase.union_old);
            var calculated_values_new = recalculationCalculatedValues(union_new);
            // Update buildings
            var buildings = recalculationBuildings(union_new, landBase.union_old, landBase.buildings.buildings);
            // Prepare for all rules interpretation so buildable area is re calculated

            console.log("union_new", union_new);

            // Save new union
            var landBase_new = { ...landBase };
            landBase_new.union.area = union_new.area;
            landBase_new.union.center = union_new.center;
            landBase_new.union.bbox = union_new.bbox;
            landBase_new.union.geometry = union_new.geometry;
            landBase_new.union.outerLine = union_new.outerLine;
            landBase_new.union.bounds = union_new.bounds;
            landBase_new.union.bounds_groups = union_new.bounds_groups;
            landBase_new.calculated_values = calculated_values_new;
            landBase_new.buildings.buildings_close = buildings.buildings_close;
            landBase_new.buildings.buildings_land = buildings.buildings_land;
            landBase_new.buildings.buildings_land_area = buildings.buildings_land_area;
            var toSaveData = { ...capacity.toSave };
            if (!toSaveData?.keys) { toSaveData.keys = [] }
            toSaveData.keys.push("landBase__union");
            toSaveData.keys.push("landBase__union_old");
            toSaveData.keys.push("landBase__division");
            toSaveData.autoSave = false; // Set to true later in processing (after recalculating buildable)
            toSaveData.action = "Division du terrain";
            toSaveData.value = "en " + capacity?.landBase?.division?.division_areas?.features.length + " zones, dont certaines non prise en compte";
            setCapacity({ ...capacity, landBase: landBase_new, toSave: toSaveData });
        }
        else {
            console.log("RESTORE OLD");
            // Save with union same as union_old
            var landBase_new = { ...landBase };
            landBase_new.union = JSON.parse(JSON.stringify(landBase.union_old));
            // Reset also other data (limits...)
            landBase_new.calculated_values = JSON.parse(JSON.stringify(landBase.union_old.memory.calculated_values));
            landBase_new.buildings.buildings_close = JSON.parse(JSON.stringify(landBase.union_old.memory.buildings_close));
            landBase_new.buildings.buildings_land = JSON.parse(JSON.stringify(landBase.union_old.memory.buildings_land));
            landBase_new.buildings.buildings_land_area = JSON.parse(JSON.stringify(landBase.union_old.memory.buildings_land_area));
            // Prepare for all rules interpretation so buildable area is re calculated

            var toSaveData = { ...capacity.toSave };
            if (!toSaveData?.keys) { toSaveData.keys = [] }
            toSaveData.keys.push("landBase__union");
            toSaveData.keys.push("landBase__union_old");
            toSaveData.keys.push("landBase__division");
            toSaveData.autoSave = false; // Set to true later in processing (after recalculating buildable)
            toSaveData.action = "Division du terrain";
            toSaveData.value = "en " + capacity?.landBase?.division?.division_areas?.features.length + " zones";
            setCapacity({ ...capacity, landBase: landBase_new, toSave: toSaveData });
        }
        setDivisionUpdateTracker((Date.now()).toString());
    }
    const handleChangeBoxChange = (div_zone_index) => {
        console.log("CHANGE", div_zone_index);
        var current_value = capacity.landBase.division.division_areas.features[div_zone_index].properties.isTaken;
        // If unchecking, verify it not the last one
        var test = true;
        if (current_value === true) {
            var nb_not_taken = 0;
            for (var i = 0; i < capacity.landBase.division.division_areas.features.length; i++) {
                if (capacity.landBase.division.division_areas.features[i].properties.isTaken === false) {
                    nb_not_taken++;
                }
            }
            console.log(nb_not_taken, capacity.landBase.division.division_areas.features.length - 1);
            if (nb_not_taken >= capacity.landBase.division.division_areas.features.length - 1) {
                test = false;
            }
        }
        if (test) {
            var landBase = { ...capacity.landBase };
            landBase.division.division_areas.features[div_zone_index].properties.isTaken = !current_value;
            setCapacity({ ...capacity, landBase: landBase });
            handleRecalculateUnion(landBase);
        }
        else {
            console.log("FORBIDEN");
        }
    }


    // DATA RECALCULATION
    const recalculationBounds = (union_new, union_old) => {
        // Loop th new bounds groups and search match with old ones
        for (var i_new = 0; i_new < union_new.bounds_groups.length; i_new++) {
            var new_bounds_group = union_new.bounds_groups[i_new];
            var match = -1;
            for (var i_old = 0; i_old < union_old.bounds_groups.length; i_old++) {
                var old_bounds_group = union_old.bounds_groups[i_old];
                // Check match
                if ((new_bounds_group.start_coord_global.join("_") === old_bounds_group.start_coord_global.join("_")) || (new_bounds_group.end_coord_global.join("_") === old_bounds_group.end_coord_global.join("_"))) {
                    console.log("MATCH ON POINTS");
                    if ((new_bounds_group.bearing > old_bounds_group.bearing - 1 && new_bounds_group.bearing < old_bounds_group.bearing + 1) && (new_bounds_group.gradient > old_bounds_group.gradient - 1 && new_bounds_group.gradient < old_bounds_group.gradient + 1) && (new_bounds_group.slope > old_bounds_group.slope - 1 && new_bounds_group.slope < old_bounds_group.slope + 1)) {
                        console.log("MATCH ON VALUES");
                        match = i_old;
                        break;
                    }
                }
            }
            // If match => add bounds group type
            if (match >= 0) {
                console.log("MATCH FOUND", new_bounds_group, union_old.bounds_groups[match]);
                new_bounds_group.context_analysis = JSON.parse(JSON.stringify(union_old.bounds_groups[match].context_analysis));
            }
            // Else => add default type to side / separation
            else {
                new_bounds_group.context_analysis.result.type = "separation";
                new_bounds_group.context_analysis.result.subtype = "side";
            }
        };

        return union_new
    }
    const recalculationCalculatedValues = (union_new) => {
        var limit_total_length = 0;
        var limit_separation_length = 0;
        var limit_public_length = 0;
        var limit_nc_length = 0;
        for (var i = 0; i < union_new.bounds_groups.length; i++) {
            limit_total_length += union_new.bounds_groups[i].length;
            if (union_new.bounds_groups[i].context_analysis.result.type === "separation") {
                limit_separation_length += union_new.bounds_groups[i].length;
            }
            else if (union_new.bounds_groups[i].context_analysis.result.type === "way") {
                limit_public_length += union_new.bounds_groups[i].length;
            }
            else {
                limit_nc_length += union_new.bounds_groups[i].length;
            }
        }
        var calculated_values = {
            limit_total_length: limit_total_length,
            limit_separation_length: limit_separation_length,
            limit_public_length: limit_public_length,
            limit_nc_length: limit_nc_length
        }

        return calculated_values
    }

    const recalculationBuildings = (union_new, union_old, buildings_list) => {
        console.log("union_new", union_new);
        console.log("union_old", union_old);
        var union_poly = union_new.geometry;
        var buildings_close = JSON.parse(JSON.stringify(union_old.memory.buildings_close));
        var buildings_land = [];
        var buildings_land_area = 0;
        union_old.memory.buildings_land.forEach(building_index => {
            var intersection = turf.intersect(union_poly, buildings_list[building_index]);
            if (intersection) {
                buildings_land.push(building_index);
                buildings_land_area += turf.area(intersection);
            }
            else {
                buildings_close.push(building_index);
            }
        })
        return { buildings_close, buildings_land, buildings_land_area }
    }


    useEffect(() => {
        if (mapDrawMode?.target?.division === true) {
            if (mapDrawMode?.mode === "update") {
                handleSaveDivision();
            }
        }
        if (mapDrawMode?.mode === null) {
            if (isDrawing) {
                console.log("CANCELED DIVISION DRAWING");
                // Show layers
                layer_Show("union");
                layer_Show("division");
            }
            setIsDrawing(false);
        }
    }, [mapDrawMode.mode]);

    // useEffect(() => {
    //     // Set up checkbox
    // }, []);


    return (
        <div>
            <div className="app__sectiondata_widget_spacer_20"></div>
            <div className="app__sectiondata_widget_title_container">
                <div id="section_2_division" className="app__sectiondata_widget_title">Division parcellaire</div>
                {capacity?.landBase?.division &&
                    <div className="app__sectiondata_widget_layer">
                        <img src={ico_map_layers} alt="ico_map_layers" />
                        <div className="app__map_layer_checkbox"><input className="app__map_layer_checkbox_element" type="checkbox" id="sectiondata_switch00" checked={mapLayers.division.isVisible} onChange={() => { layer_Toggle("division") }} /><label className="app__map_layer_checkbox_label" htmlFor="sectiondata_switch00">Toggle</label></div>
                    </div>
                }
            </div>
            <div className="app__sectiondata__widget" style={{ position: 'relative' }}>
                <div className="app__landsvalidation_info_container">
                    <div className="app__landsvalidation_info_text_container">
                        {capacity?.landBase?.division ?
                            <>
                                <div>Le terrain est divisé en <strong>{capacity?.landBase?.division?.division_areas?.features.length > 1 ? (capacity?.landBase?.division?.division_areas?.features.length + " zones") : "1 zone"}</strong>.</div>
                                {/* <div>La surface totale prise en compte dans l'étude est de <strong>{helpers.get_pretty_num(capacity?.landBase?.division?.division_areas?.features.reduce((a, b) => a + b.properties.area, 0).toFixed(0))} m²</strong>, soit <strong>{Math.ceil(100 * (capacity?.landBase?.division?.division_areas?.features.reduce((a, b) => a + b.properties.area, 0).toFixed(0)) / (capacity?.landBase?.union_old.area))} %</strong> de la surface du terrain.</div> */}
                                <div>La surface totale prise en compte dans l'étude est de <strong>{helpers.get_pretty_num(capacity.landBase.union.area.toFixed(0))} m²</strong>, soit <strong>{Math.ceil(100 * (capacity.landBase.union.area) / (capacity?.landBase?.union_old.area))} %</strong> de la surface du terrain.</div>
                            </>
                            :
                            <div>Le terrain <strong>n'est pas divisé</strong>, il est pris en compte dans sa totalité pour cette étude.</div>
                        }
                    </div>
                    <div className={`app__landsvalidation_info_buttons_container ${(isDrawing || isDelete) ? "app__landsvalidation_info_buttons_container_hidden" : ""}`}>
                        {capacity?.landBase?.division ?
                            <>
                                <div className="app__landsvalidation_popup_button" onClick={() => { openDraw() }}>Modifier la division</div>
                                <div className="app__landsvalidation_popup_button_second" onClick={() => { setIsDelete(true) }}>Supprimer la division</div>
                            </>
                            :
                            <div className="app__landsvalidation_popup_button" onClick={() => { openDraw() }}>Commencer la division</div>
                        }
                    </div>
                </div>
                {isDelete &&
                    <div className="app__landsvalidation_actions_container">
                        <div className="app__bound_type_modify_title_big" style={{ color: "#062134", fontWeight: "600", margin: "0px" }}>Supprimer la division ?</div>
                        <div className="app__ruleset_document_deletion_container" style={{ width: "300px" }}>
                            <div className="app__landsvalidation_popup_button" onClick={() => { setIsDelete(false) }}>Conserver</div>
                            <div className="app__landsvalidation_popup_button_second" onClick={() => { handleDeleteDivision() }}>Supprimer</div>
                        </div>
                    </div>
                }
            </div>
            {capacity?.landBase?.division &&
                <>
                    <div className="app__sectiondata_widget_spacer_20"></div>
                    <div className="app__sectiondata__widget">
                        <div className="app__sectiondata_widget_title">Liste des zones issues de la division</div>
                        <div>
                            {capacity.landBase.division.division_areas.features.map((div_zone, div_zone_index) => {
                                return (
                                    <div className="app__bound_container">
                                        {div_zone_index === 0 ?
                                            <div className="app__bound_title_container">
                                                <div className="app__bound_title app_bound_col0">Numéro de zone</div>
                                                <div className="app__bound_title app_bound_col1">Surface</div>
                                                <div className="app__bound_title app_bound_col2">Prise en compte dans l'étude</div>
                                            </div>
                                            :
                                            <div className="app__bound_line_container"></div>
                                        }
                                        <div className="app__bound_body_container">
                                            <div className="app__bound_body_value_main app_bound_col0">{"Division " + div_zone.properties.label}</div>
                                            <div className="app__bound_body_value app_bound_col1">{helpers.get_pretty_num(div_zone.properties.area.toFixed(0))} m²</div>
                                            {/* <div className="app__bound_body_value app_bound_col2">{div_zone.properties.isTaken ? "Prise en compte dans l'étude" : "Non prise en compte dans l'étude"}</div> */}
                                            <div className="app__bound_body_value app_bound_col2">
                                                <div className={`app__landsvalidation_checkbox_line ${(isDrawing || isDelete) ? "app__landsvalidation_info_buttons_container_hidden" : ""}`}><input className="app__landsvalidation_checkbox" type="checkbox" id={"cb_division_" + div_zone_index} onChange={() => { handleChangeBoxChange(div_zone_index) }} checked={div_zone.properties.isTaken} /><label className="app__landsvalidation_checkbox_label" htmlFor={"cb_division_" + div_zone_index}>{div_zone.properties.isTaken ? "Prise en compte dans l'étude" : "Non prise en compte dans l'étude"}</label></div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </>
            }
            <div className="app__sectiondata_widget_spacer_20"></div>
        </div>
    );
};

export default LandsDivision;